import { render, staticRenderFns } from "./TagsRegister.vue?vue&type=template&id=f1be935c&scoped=true"
import script from "./TagsRegister.vue?vue&type=script&lang=js"
export * from "./TagsRegister.vue?vue&type=script&lang=js"
import style0 from "./TagsRegister.vue?vue&type=style&index=0&id=f1be935c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1be935c",
  null
  
)

export default component.exports